export function extractUploadErrorMessages(source: any): string[] {
  const body = source && source.error !== undefined && source.status !== undefined ? source.error : source;
  if (body && body.messageError) {
    return String(body.messageError).split(/;\s*/).map(s => s.trim()).filter(Boolean);
  }
  return ['Ocurrió un error al cargar el archivo. Verifica el formato y vuelve a intentarlo.'];
}
